/**
 * Fetch wrapper that suppresses error logging in production
 * This won't prevent browser's native network errors, but helps with application-level logging
 */

// Only override in production
if (import.meta.env.PROD) {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
        try {
            const response = await originalFetch(...args);
            return response;
        } catch (error) {
            // Suppress logging for expected API errors
            const url = args[0]?.toString() || '';
            const isSupabaseFunction = url.includes('supabase.co/functions') || url.includes('bedrock-invocations');

            if (!isSupabaseFunction) {
                // Only log non-Supabase errors
                console.error('Fetch error:', error);
            }

            // Re-throw the error so application can handle it
            throw error;
        }
    };
}

export default {};
